/**
 * ADR-0073 §7: the one hook every screen uses to learn what runs for this
 * workspace's data per AI feature (AI provider, deterministic path, or off with
 * an action). Shares the ['federal-parity', slug] cache, which data-mode,
 * field-class and provider changes invalidate.
 */
import { useQuery } from '@tanstack/react-query';
import { getFederalParity, type FeatureParity, type ParityActionView } from './api';
import { queryKeys } from './query-keys';

export function useFederalParity(slug: string) {
  return useQuery({ queryKey: queryKeys.federalParity(slug), queryFn: () => getFederalParity(slug), enabled: !!slug, retry: false, staleTime: 60_000 });
}

/** The status for one feature (undefined while loading or when the call failed). */
export function useFeatureParity(slug: string, feature: string): FeatureParity | undefined {
  return useFederalParity(slug).data?.features.find((f) => f.feature === feature);
}

const RANK: Record<string, number> = { viewer: 0, advisor: 0, assessor: 0, member: 0, editor: 1, admin: 2, owner: 3 };
/** Can this membership role take the action itself (else: ask someone who can)? */
export function canTakeAction(role: string, action: ParityActionView): boolean {
  return (RANK[role] ?? 0) >= (RANK[action.role] ?? 3);
}
